module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_RO-83725b188807f2183a21280f3a4253e3.svg";